import React, { Component, RefObject } from 'react';
import { connect } from 'react-redux';
import { ELSDayPickerType } from 'models/els';
import { DATE_FORMAT, DATE_FORMAT_ANZ, Locales } from 'constants/app.constant';
import { dateTimeHelper } from 'helpers';
import { appSelectors } from 'redux/ducks/app';
import DateView from './DateView';
import './sng.date.scss';

export interface SNGDateProps {
  value: string;
  onDateChange: Function;
  componentRef?: RefObject<ELSDayPickerType>;
  disableAfter?: Date;
  disableBefore?: Date;
  id: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  selectOnly?: boolean;
  isDisabled?: boolean;
  inputAriaLabel?: string;
  ariaRequired?: boolean;
  usePropValue?: boolean;
  locale?: Locales;
  placeHolder?: string;
}

class SNGDate extends Component<SNGDateProps> {
  static displayName = 'SNGDate';

  render() {
    const { value, onBlur, selectOnly, isDisabled, inputAriaLabel, ariaRequired, locale, placeHolder = '' } = this.props;
    const dateFormat = locale === Locales.EN_US ? DATE_FORMAT : DATE_FORMAT_ANZ;

    return (
      <div className="sng-date-container">
        <DateView
          {...this.props}
          id={this.props.id}
          value={value}
          disableBefore={this.props.disableBefore}
          disableAfter={this.props.disableAfter}
          isDisabled={isDisabled}
          inputAriaLabel={inputAriaLabel}
          ariaRequired={ariaRequired}
          placeHolder={placeHolder}
          format={dateFormat}
          formatDate={(date, format) => dateTimeHelper.datePickerFormatterWithCustomFormat(date, format)}
          parseDate={(str, format) => dateTimeHelper.datePickerParserWithCustomFormat(str, format)}
          handleDateChange={(e, v) => this.props.onDateChange(v)}
          textFieldProps={{
            onBlur,
            readOnly: selectOnly,
            'aria-label': inputAriaLabel || 'Input date field',
            'aria-required': ariaRequired
          }}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  locale: appSelectors.getLocale(state)
});
export default connect(mapStateToProps)(SNGDate);
